"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchDataGrid = exports.searchFieldDiv = exports.searchFilterDiv = exports.filterField = exports.searchFieldFilter = exports.flowFieldDetailsLabelsStyle = exports.columnAndFieldDetailsLabelsStyle = exports.ColumnFieldsWrapper = exports.columnFieldsWrapperMaxRows = exports.ColumnDetailsPlaceholder = exports.ColumnAndFieldDetailsTagsEditorWrapper = exports.ColumnAndFieldDetailsTextAreaWrapper = exports.ColumnAndFieldDetailsTableCell = exports.ColumnAndFieldDetailsDescriptionValue = exports.ColumnAndFieldDetailsValue = exports.ColumnAndFieldDetailsLabel = exports.ColumnAndFieldDetailsProperty = exports.columnDetailsTextAreaStyle = exports.SaveAndCancelButtonsFlexWrapperSharedStyle = exports.SaveAndCancelButtonsWrapper = exports.detailsDialogActionsMenuButtonStyle = exports.inlineActionsMenuButtonStyle = exports.columnActionsMenuStyle = exports.ActionMenuProperties = exports.ColumnDetailsProperties = exports.ColumnDetailsTypeRow = exports.ColumnDetailsColumnName = exports.ColumnDetailsPane = exports.descriptionMaxHeight = void 0;
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
exports.descriptionMaxHeight = 60;
const rowHeight = widgets_1.TabStyles.Typography.Sizing.XLarge;
exports.ColumnDetailsPane = (0, vizportalclient_common_components_1.divWithStyle)('ColumnDetailsPane', Object.assign(Object.assign({}, data_catalog_shared_1.vizPortalFontStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default }));
exports.ColumnDetailsColumnName = (0, vizportalclient_common_components_1.divWithStyle)('ColumnDetailsColumnName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
});
exports.ColumnDetailsTypeRow = (0, vizportalclient_common_components_1.divWithStyle)('ColumnDetailsTypeRow', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
exports.ColumnDetailsProperties = (0, vizportalclient_common_components_1.divWithStyle)('ColumnDetailsProperties', {
    display: 'table',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    width: '100%',
});
exports.ActionMenuProperties = (0, vizportalclient_common_components_1.divWithStyle)('ActionsMenuProperties', {
    position: 'absolute',
    verticalAlign: 'middle',
    right: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    display: 'flex',
    flexDirection: 'column',
});
exports.columnActionsMenuStyle = {
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
};
exports.inlineActionsMenuButtonStyle = {
    padding: widgets_1.TabStyles.Spacing.SmallSpace,
    cursor: 'pointer',
    verticalAlign: 'middle',
    minWidth: 0,
    height: widgets_1.TabStyles.Sizing.RowHeight,
    width: widgets_1.TabStyles.Sizing.RowHeight,
};
exports.detailsDialogActionsMenuButtonStyle = {
    padding: widgets_1.TabStyles.Spacing.SmallSpace,
    cursor: 'pointer',
    verticalAlign: 'middle',
    minWidth: 0,
    height: widgets_1.TabStyles.Sizing.RowHeight + 5,
    width: widgets_1.TabStyles.Sizing.RowHeight + 5,
};
exports.SaveAndCancelButtonsWrapper = (0, vizportalclient_common_components_1.divWithStyle)('SaveAndCancelButtonsWrapper', {
    position: 'relative',
});
exports.SaveAndCancelButtonsFlexWrapperSharedStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace * 2,
    marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
};
exports.columnDetailsTextAreaStyle = {
    marginTop: 10,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    // eslint-disable-next-line deprecation/deprecation
    fontFamily: widgets_1.TabStyles.Typography.FontFamily,
    color: widgets_1.TabStyles.Typography.Color.Primary,
    resize: 'none',
    outline: 'none',
    flex: 1,
    width: '100%',
};
exports.ColumnAndFieldDetailsProperty = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsProperty', {
    display: 'table-row',
});
exports.ColumnAndFieldDetailsLabel = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsLabel', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    verticalAlign: 'top',
});
exports.ColumnAndFieldDetailsValue = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsValue', {
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    maxWidth: '300px',
    maxHeight: '150px',
    overflow: 'auto',
});
exports.ColumnAndFieldDetailsDescriptionValue = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsDescriptionValue', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    overflowY: 'auto',
    wordBreak: 'break-word',
});
exports.ColumnAndFieldDetailsTableCell = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsTableCell', {
    display: 'table-cell',
});
exports.ColumnAndFieldDetailsTextAreaWrapper = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsTextAreaWrapper', {
    display: 'flex',
});
exports.ColumnAndFieldDetailsTagsEditorWrapper = (0, vizportalclient_common_components_1.divWithStyle)('ColumnAndFieldDetailsTagsEditorWrapper', {
    flex: '1 1 0%',
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
exports.ColumnDetailsPlaceholder = (0, vizportalclient_common_components_1.divWithStyle)('ColumnDetailsPlaceholder', {
    fontStyle: 'italic',
    color: widgets_1.TabStyles.Typography.Color.Secondary,
});
exports.columnFieldsWrapperMaxRows = 4.5;
exports.ColumnFieldsWrapper = (0, vizportalclient_common_components_1.divWithStyle)('ColumnFieldsWrapper', {
    width: '100%',
    lineHeight: `${rowHeight}px`,
    verticalAlign: 'top',
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    $nest: {
        '> div': {
            height: 'inherit',
            maxHeight: rowHeight * exports.columnFieldsWrapperMaxRows,
            overflow: 'auto',
        },
    },
});
exports.columnAndFieldDetailsLabelsStyle = {
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace + 2,
    marginTop: widgets_1.TabStyles.Spacing.SmallSpace,
    display: 'inline-block',
};
exports.flowFieldDetailsLabelsStyle = {
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace + 2,
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    display: 'inline-block',
};
exports.searchFieldFilter = (0, vizportalclient_common_components_1.cssClass)('search-field-filter', {
    display: 'flex',
    flexFlow: 'column',
    overflow: 'auto',
    alignSelf: 'flex-end',
});
exports.filterField = (0, vizportalclient_common_components_1.cssClass)('filter-field', {
    display: 'flex',
    flexFlow: 'column',
    alignSelf: 'flex-end',
    margin: '0pt 10pt',
});
exports.searchFilterDiv = (0, vizportalclient_common_components_1.cssClass)('search-filter-div', {
    display: 'flex',
    alignSelf: 'flex-end',
});
exports.searchFieldDiv = (0, vizportalclient_common_components_1.cssClass)('search-field-div', {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 'inherit',
});
exports.searchDataGrid = (0, vizportalclient_common_components_1.cssClass)('search-data-grid', {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 'inherit',
});
//# sourceMappingURL=ColumnAndFieldDetailsStyles.js.map